import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {AuthorizationService} from "../../services/authorization.service";

export const adminGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(AuthorizationService);
  return permissionService.isAdmin();
};
